import LastOperation from './LastOperation';

export default LastOperation;
